import { render, staticRenderFns } from "./ConfigRecoverTableButton.vue?vue&type=template&id=2bf4e3b8&scoped=true&"
import script from "./ConfigRecoverTableButton.vue?vue&type=script&lang=js&"
export * from "./ConfigRecoverTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4e3b8",
  null
  
)

export default component.exports